export enum Role {
    Administrator = "Administrator",
    Coach = "Coach",
    ExternalAdvisor = "ExternalAdvisor",
    AgreementManager = "AgreementManager",
    FinanceManager = "FinanceManager",
    EsfAdministrator = "EsfAdministrator",
    Vagledare = "Vagledare",
    FordjupadVagledare = "FordjupadVagledare",
}